import React from 'react';
import { MeatballPanelConfiguration } from 'ui/common/types';
import styles from './meatball-panel.scss';

export interface MeatballPanelProps {
  configuration?: MeatballPanelConfiguration;
}

export const MeatballPanel = ({ configuration }: MeatballPanelProps) => configuration ?
  <div className={styles.labelWithMeatball}>
    {configuration?.panel}
    {configuration?.meatball}
  </div> : null;
